import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ModalContext } from 'App';
import * as actions from '../action';
import * as c from '../constant';
import ReasonModal from '../modals/ReasonModal';

function MachineryPropertyAssessmentContainer({
  getList,
  machineryPropertyAssessmentList,
  updateMachineryPropertyAssessmentTaxability,
  applicationId,
  isLoading,
}) {
  const setModal = useContext(ModalContext);
  const handleChange = (e, id, data) => {
    if (e.target.checked === true) {
      const args = {
        taxability: 1,
        reason: '',
        tax_exempt_code_id: '',
      };
      updateMachineryPropertyAssessmentTaxability(id, data.id, args, () =>
        getList(id)
      );
      return;
    }
    setModal({
      isOpen: true,
      content: (
        <ReasonModal
          id={data.id}
          applicationId={id}
          updateList={data.attributes}
        />
      ),
      title: 'Add Exemption Reason',
      modalSize: 'modal-md',
    });
  };

  useEffect(() => {
    if (_.isEmpty(applicationId)) return;
    getList(applicationId);
  }, []);
  useEffect(() => {
    if (_.isEmpty(applicationId)) return;
    getList(applicationId);
  }, [applicationId]);

  return (
    <div className="card-content-listing">
      <div className="card p-0 mr-2">
        {isLoading ? (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        ) : (
          <>
            <div className="row my-3 mx-2">
              <div className="table-div">
                <table className="css-table table table-borderless table-sm table-striped table-hover">
                  <thead className="table-header">
                    <tr>
                      <td className="font-weight-bold" width="150">
                        Actual Use
                      </td>
                      <td className="font-weight-bold">Market Value</td>
                      <td className="font-weight-bold">Assessment Level</td>
                      <td className="font-weight-bold">Assessed Value</td>
                      <td className="font-weight-bold">Taxability</td>
                      <td className="font-weight-bold" width="150">
                        Tax Exempt Code
                      </td>
                      <td className="font-weight-bold">Exemption Reason</td>
                    </tr>
                  </thead>
                  <tbody>
                    {machineryPropertyAssessmentList &&
                      machineryPropertyAssessmentList.length <= 0 && (
                        <tr className="text-center">
                          <td className="history-color" colSpan="9">
                            No data
                          </td>
                        </tr>
                      )}
                    {machineryPropertyAssessmentList &&
                      machineryPropertyAssessmentList.map((item) => (
                        <tr key={item.id}>
                          <td className="history-color">
                            {_.get(item, 'attributes.actual_use_name')}
                          </td>
                          <td className="history-color">
                            {_.get(item, 'attributes.market_value')}
                          </td>
                          <td className="history-color">
                            {_.get(item, 'attributes.assessment_level')}
                          </td>
                          <td className="history-color">
                            {_.get(item, 'attributes.assessed_value')}
                          </td>
                          <td className="history-color">
                            <input
                              name="taxability"
                              type="checkbox"
                              checked={_.get(item, 'attributes.taxability')}
                              onChange={(e) =>
                                handleChange(e, applicationId, item)
                              }
                            />
                          </td>
                          <td className="history-color">
                            {_.get(item, 'attributes.tax_exempt_code_name')}
                          </td>
                          <td className="history-color">
                            {_.get(item, 'attributes.tax_exempt_reason')}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

MachineryPropertyAssessmentContainer.defaultProps = {
  applicationId: '',
};

MachineryPropertyAssessmentContainer.propTypes = {
  getList: PropTypes.instanceOf(Function).isRequired,
  machineryPropertyAssessmentList: PropTypes.instanceOf(Array).isRequired,
  updateMachineryPropertyAssessmentTaxability:
    PropTypes.instanceOf(Function).isRequired,
  applicationId: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  machineryPropertyAssessmentList:
    _.get(api, `${c.GET_MACHINERY_PROPERTY_ASSESSMENT}.list`) || [],
  isLoading:
    _.get(api, 'loading', []).indexOf(c.GET_MACHINERY_PROPERTY_ASSESSMENT) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(MachineryPropertyAssessmentContainer);
